module.exports = __webpack_public_path__ + "img/2024-11-15b_2.0e2d79d4.jpg";